import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, useRouteMatch } from 'react-router-dom';

import { STAGE_STATUS_FINISH } from 'utils/profile-stages';

// TODO: Check if stage is empty, we need to get the values for that,
// calling getValues for each stage multiple times may be too much.
// So maybe saving the values on the stage wen we get them the first time?

const RedirectToFirst = ({ stages }) => {
  const { path } = useRouteMatch();
  const first = stages.find(({ status }) => {
    const isEmpty = true;
    return status !== STAGE_STATUS_FINISH || isEmpty;
  });
  const to = `${path}/${first.path}`;
  return <Redirect to={to} />;
};

RedirectToFirst.propTypes = {
  stages: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

RedirectToFirst.defaultProps = {};

export default RedirectToFirst;
